import { DashboardCard } from "../../dashboard-card";

export function FilesContent() {
  const mockFiles = [
    {
      id: "1",
      name: "patient_lab_results.pdf",
      type: "PDF",
      size: "1.7MB",
      dateAdded: "12/15/2024",
      onDelete: () => console.log("File deleted"),
    },
    {
      id: "2",
      name: "insurance_card_front.jpg",
      type: "JPEG",
      size: "2.1MB",
      dateAdded: "12/10/2024",
      onDelete: () => console.log("File deleted"),
    },
    {
      id: "3",
      name: "treatment_notes.docx",
      type: "DOCX",
      size: "845KB",
      dateAdded: "12/08/2024",
      onDelete: () => console.log("File deleted"),
    },
    {
      id: "4",
      name: "x_ray_scan.png",
      type: "PNG",
      size: "3.2MB",
      dateAdded: "12/05/2024",
      onDelete: () => console.log("File deleted"),
    },
    {
      id: "5",
      name: "prescription_details.pdf",
      type: "PDF",
      size: "1.1MB",
      dateAdded: "12/01/2024",
      onDelete: () => console.log("File deleted"),
    },
  ];

  return (
    <div className="flex-1 overflow-y-auto space-y-4 pr-2">
      {mockFiles.map((file) => (
        <DashboardCard
          key={file.id}
          statusLabel=""
          title={file.name}
          subtitle={file.type}
          subtitleSecondary={file.size}
          assignees={null}
          description={file.dateAdded}
          dueDate=""
          priority=""
          timestamp={undefined}
          onDelete={file.onDelete}
        />
      ))}
    </div>
  );
}
